export const CACHE_DOWN_TABLE_NAMES = {
    Alias: 'alias',
    AuditCampaign: "auditCampaign",
    AuditRecord: "auditRecord",
    Authority: 'authority',
    Collaborator: "collaborators",
    ConditionReport: 'conditionReport',
    EntityField: 'entityField',
    Expression: 'expression',
    Item: 'item',
    Location: 'location',
    Manifestation: 'manifestation',
    numericMuseumItem: "item",
    physicalMuseumItem: "item",
    Thesaurus: "thesaurus",
    ThesaurusTerm: "thesaurusTerm",
    Translation: 'translation',
    Work: 'work',
    Specimen: 'specimen'
}

export const CACHE_UP_TABLE_NAMES = {
    AuditCampaign: "auditCampaign",
    AuditRecord: "auditRecord",
    ConditionReport: 'conditionReport',
    Expression: 'expression',
    Item: 'item',
    Manifestation: 'manifestation',
    Work: 'work',
    Specimen: 'specimen'
}